/* eslint-disable no-unused-vars */
// jl-design-system
import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import PropTypes from "prop-types";
import React, { useState } from "react";
// Components
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";
import EscalateEmailForm from "./email-form/EscalateEmailForm";
import Step from "./email-form/Step";
import EmailQuestions from "./email-questions/EmailQuestions";
// Styles
import { escalateComplaintsData } from "../../data/escalate";
import styles from "./email-form-node.module.scss";

function EscalateEmailFormNode({ onSubmitted, source, isLiveChatInEmailUsEnabled, isHideFlooringsActive }) {
  const [questionsResponse, setQuestionsResponse] = useState(null);
  const emailData = escalateComplaintsData(isHideFlooringsActive);
  const handleAllQuestionsAnswered = v => {
    if (v) {
      dispatchNewEvent("dataStateChange", {
        action: "emailUs.formLoaded",
        topic: v.formData.subject,
      });
    }
    setQuestionsResponse(v);
  };

  return (
    <div className={styles["email-form-node"]}>
      {/* Replacing div with section tag as sibling div classes gets attached to it */}
      <div className={styles["step-container-wrapper"]}>
        <Step index={1} title="How can we help" />
      </div>
      <EmailQuestions
        onFinished={handleAllQuestionsAnswered}
        emailData={emailData}
        isLiveChatInEmailUsEnabled={isLiveChatInEmailUsEnabled}
      />
      {questionsResponse ? (
        <div className={styles["email-form-node__container"]}>
          <div className={styles["email-form-node__inner-container"]}>
            <div className={styles["email-form-node__form"]}>
              {questionsResponse.formData?.message ? (
                <Message
                  dataTest="message"
                  className={styles.messageBox}
                  type="information"
                  title={questionsResponse.formData?.title || "Did you know..."}
                  body={questionsResponse.formData?.message}
                  whiteBackground
                  wideTab
                />
              ) : null}
              {questionsResponse.formData?.fields ? (
                <EscalateEmailForm
                  subject={questionsResponse.formData.subject}
                  shop={questionsResponse.shop}
                  fields={["CASE_NUMBER", ...questionsResponse.formData.fields]}
                  imageMessage={questionsResponse.formData.imageMessage}
                  onSubmitted={onSubmitted}
                  id={questionsResponse.formData.subject}
                  source={source}
                />
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

EscalateEmailFormNode.defaultProps = {
  onSubmitted: () => {},
  source: undefined,
  isLiveChatInEmailUsEnabled: false,
  isHideFlooringsActive: false,
};

EscalateEmailFormNode.propTypes = {
  onSubmitted: PropTypes.func,
  source: PropTypes.string,
  isLiveChatInEmailUsEnabled: PropTypes.bool,
  isHideFlooringsActive: PropTypes.bool,
};

export default EscalateEmailFormNode;
